import BreakdownTabs from './BreakdownTabs';

export default BreakdownTabs;

export { breakdownTabId } from './BreakdownTabs';
export type { IBreakdownTab, IBreakdownTabsProps } from './BreakdownTabs';
